import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=e283f146&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=e283f146&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e283f146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e283f146')) {
      api.createRecord('e283f146', component.options)
    } else {
      api.reload('e283f146', component.options)
    }
    module.hot.accept("./classification.vue?vue&type=template&id=e283f146&scoped=true", function () {
      api.rerender('e283f146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/scrunchieArrangement/components/classification.vue"
export default component.exports